import { fetchClaimListDatas } from "../../api/claim";
import { AadharUploadResponseDTO, BankDetailsVerify, ClaimDetailsDTO, KYCUploadResponseDTO, medicalIRDocuments, userLoginDetails } from "../../modules/claim/models/claimDetails.models";
import { ClaimListDetails, ClaimListRequest, ClaimListResponse } from "../../modules/claim/models/claimList.models";
import { ChequeUploadResponse, PanUploadResponse } from "../../modules/claim/models/kyc.models";
import { PhotoDetailsResponse, selfieUploadRequestResponseDto } from "../../modules/claim/models/selfie.model";
import { filterClaimListRequest } from "../../modules/profile/Account.model";
import { ActionType } from "../action-type";
import { fetch_Api_Details_Fail, fetch_Api_Details_Start } from "./commonAction";

const reduxRefreshTime = Number(20 * 60 * 1000);
const _ = require('lodash');
export const verifyBank = (bankDet: BankDetailsVerify) => {
    return (dispatch) => {
        dispatch({
            type: 'bank',
            payload: bankDet
        });
    }
}
export const ssoLogin = (ssoObject) => {
    return (dispatch) => {
        dispatch({
            type: 'sso',
            payload: ssoObject
        });
    }
}

export const verifyPAN = (panDet: BankDetailsVerify) => {
    return (dispatch) => {
        dispatch({
            type: 'pan',
            payload: panDet
        });
    }
}

export const StoreClaimDetails = (claimDetails: ClaimDetailsDTO) => {
    return (dispatch) => {
        dispatch({
            type: 'claim',
            payload: claimDetails
        });
    }
}

export const MedicalIRUploaded = (files: medicalIRDocuments) => {
    return (dispatch) => {
        dispatch({
            type: 'medical',
            payload: files
        });
    }
}

export const KYCIRUploaded = (files: any[]) => {
    return (dispatch) => {
        dispatch({
            type: 'kyc',
            payload: files
        });
    }
}

export const KYCUpdatedDetails = (detail: KYCUploadResponseDTO) => {
    return (dispatch) => {
        dispatch({
            type: 'kycDetails',
            payload: detail
        });
    }
}

export const userLogin = (userObj: userLoginDetails) => {
    return (dispatch) =>
        dispatch({
            type: "SET_USER",
            payload: userObj
        })
}

export const selfieDetails = (details: selfieUploadRequestResponseDto) => {
    return (dispatch) => {
        dispatch({
            type: 'selfieDetails',
            payload: details
        });
    }
}

export const PanDetails = (obj: PanUploadResponse) => {
    return (dispatch) =>
        dispatch({
            type: "panDetails",
            payload: obj
        })
}

export const  kycUploadDetails=(obj:any)=>{
    return (dispatch) =>
    dispatch({
        type: "kycUploadDetails",
        payload: obj
    })

}

export const ChequeDetails = (obj: ChequeUploadResponse) => {
    return (dispatch) =>
        dispatch({
            type: "chequeDetails",
            payload: obj
        })
}

export const Logout = () => {
    return { type: 'LOGOUT' }
}

export const fetch_ClaimList_Details = (payload :filterClaimListRequest) => {
    return (dispatch) => {
        dispatch(fetch_Api_Details_Start(ActionType.FETCH_CLAIMLIST_START));
        fetchClaimListDatas(payload).then((claimListDetails: ClaimListResponse) => {

            if (claimListDetails && claimListDetails.isSuccess && claimListDetails.searchResults) {
                  dispatch({
                    type: ActionType.FETCH_CLAIMLIST_SUCCESS,
                    ClaimList: claimListDetails.searchResults,
                    timeStamp: Date.now() + reduxRefreshTime,
                })
              }
            if (claimListDetails && (!claimListDetails.isSuccess)) {
                dispatch(fetch_Api_Details_Fail(ActionType.FETCH_CLAIMLIST_FAIL, claimListDetails.error));
            }
        }).catch((error) => {
            dispatch(fetch_Api_Details_Fail(ActionType.FETCH_CLAIMLIST_FAIL, error.message));
        })
    }
}
